import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import PublicLayout from "@/components/PublicLayout";
import ContextFeed from "@/components/ContextFeed";
import EmbedSnippet from "@/components/EmbedSnippet";
import { useSeo } from "@/lib/seo";
import { Leaf, MapPin, Tag, Buildings, ForkKnife, GlobeHemisphereWest } from "@phosphor-icons/react";

const TYPE_META = {
  species: { icon: Leaf, label: "Species", color: "#16A34A" },
  place: { icon: MapPin, label: "Place", color: "#F27A54" },
  landmark: { icon: Buildings, label: "Landmark", color: "#7C3AED" },
  tag: { icon: Tag, label: "Tag", color: "#0EA5E9" },
  food: { icon: ForkKnife, label: "Food", color: "#F97316" },
  domain: { icon: GlobeHemisphereWest, label: "Category", color: "#64748B" },
};

export default function EntityPage() {
  const { type, slug } = useParams();
  const [info, setInfo] = useState(undefined);
  const meta = TYPE_META[type] || TYPE_META.tag;
  const Icon = meta.icon;

  useEffect(() => {
    axios.get(`${API}/public/entity/${type}/${slug}`).then((r) => setInfo(r.data)).catch(() => setInfo(null));
  }, [type, slug]);

  useSeo({
    title: info?.entity ? `${info.entity.name} — PhotoPulse` : "PhotoPulse",
    description: info?.entity ? `Photographs of ${info.entity.name} on PhotoPulse.pro` : "",
  });

  return (
    <PublicLayout>
      <div className="mx-auto max-w-[1200px] px-5 py-8">
        <div className="flex items-center gap-2" style={{ color: meta.color }}>
          <Icon size={22} weight="fill" />
          <p className="overline text-[10px]">{meta.label}</p>
        </div>
        <h1 data-testid="entity-title" className="mt-1 font-display text-3xl font-black tracking-tight">
          {info?.entity?.name || slug?.replace(/-/g, " ")}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {info ? `${info.count} contextual photograph${info.count === 1 ? "" : "s"} across PhotoPulse` : "Loading…"}
        </p>

        <div className="mt-6">
          <ContextFeed entityType={type} entityId={slug} limit={48} showEmpty />
        </div>

        <EmbedSnippet entityType={type} entityId={slug} title={info?.entity?.name} />

        <div className="mt-8 border-t border-border pt-4">
          <Link to="/explore" className="text-sm font-semibold text-[#F27A54] hover:underline">← Explore all photos</Link>
        </div>
      </div>
    </PublicLayout>
  );
}
